import MappingFieldsConfig from "@/components/POI/MappingFieldsConfig/MappingFieldsConfig.vue";
export default {
  name: "POIMappingFields",
  components: { MappingFieldsConfig }
};
